var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPhoneMini = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone",
    clipPath: "url(#clip0_442_573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.5 8.46005V9.96005C11.5005 10.0993 11.472 10.2371 11.4162 10.3647C11.3604 10.4923 11.2786 10.6068 11.176 10.701C11.0734 10.7951 10.9523 10.8668 10.8203 10.9114C10.6884 10.956 10.5487 10.9726 10.41 10.96C8.87138 10.7929 7.39347 10.2671 6.09497 9.42505C4.88688 8.65738 3.86263 7.63313 3.09497 6.42505C2.24996 5.12065 1.72409 3.63555 1.55997 2.09005C1.54747 1.95178 1.5639 1.81243 1.60822 1.68086C1.65253 1.54929 1.72375 1.42839 1.81735 1.32586C1.91095 1.22332 2.02487 1.1414 2.15186 1.08531C2.27886 1.02922 2.41614 1.00018 2.55497 1.00005H4.05497C4.29762 0.99766 4.53286 1.08359 4.71685 1.24181C4.90083 1.40004 5.02101 1.61977 5.05497 1.86005C5.11828 2.34008 5.23569 2.81141 5.40497 3.26505C5.47224 3.44401 5.4868 3.63851 5.44692 3.82549C5.40704 4.01247 5.3144 4.1841 5.17997 4.32005L4.54497 4.95505C5.25674 6.20682 6.29319 7.24327 7.54497 7.95505L8.17997 7.32005C8.31591 7.18562 8.48754 7.09297 8.67453 7.0531C8.86151 7.01322 9.056 7.02778 9.23497 7.09505C9.6886 7.26432 10.1599 7.38174 10.64 7.44505C10.8828 7.47931 11.1047 7.60165 11.2632 7.7888C11.4218 7.97594 11.5061 8.21484 11.5 8.46005Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhoneMini, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/phone-mini.99c0ddc6.svg";
export { ForwardRef as ReactComponent };